class TimerLoop {
  constructor({ date, time, timeZone, onComplete, onHold }) {
    this.date = date;
    this.time = time;
    this.timeZone = timeZone;
    this.onCompleteCallBack = onComplete;
    this.onHoldCallBack = onHold;
    this.loop = null;
    this.loopHold = null;
    this.loopComplete = null;
  }

  getOffset = () => {
    return new Date()
      .toLocaleString('en-US', {
        timeZone: this.timeZone,
        timeZoneName: 'longOffset',
      })
      .replaceAll(':', '')
      .match(/([-\+][0-9]+)/)[1];
  };

  initLoop = () => {
    this.loop = setInterval(() => {
      this.timerCal();
    }, 1000);
  };

  clearAllIntervals = () => {
    if (this.loopHold) {
      clearInterval(this.loopHold);
      this.loopHold = null;
    }
    if (this.loopComplete) {
      clearInterval(this.loopComplete);
      this.loopComplete = null;
    }
  };

  timerCal = () => {
    const currentDateTime = new Date();
    const endDateTime = new Date(
      `${this.date}T${this.time}${this.getOffset(this.timeZone)}`,
    );

    const endTimeDiff = endDateTime - currentDateTime;

    if (endTimeDiff > 0) {
      if (this.onHoldCallBack) {
        this.clearAllIntervals();
        this.loopHold = setInterval(() => {
          this.onHoldCallBack();
        }, 1000);
      }
      return;
    }

    clearInterval(this.loop);
    if (this.onCompleteCallBack) {
      this.clearAllIntervals();
      this.loopComplete = setInterval(() => {
        this.onCompleteCallBack();
      }, 1000);
    }
  };
}

// const setBtnClasses = (behavior) => {
//   const btns = document.querySelectorAll('.btn.btn--full.add-to-cart');
//   const bisBtns = document.querySelectorAll('preorder-opener');
//   btns.forEach((btn) => {
//     if (behavior === 'show-add-to-cart') {
//       btn.classList.remove('hide', 'btn--loading');
//     } else {
//       btn.classList.add('hide');
//     }
//   });
//   bisBtns.forEach((container) => {
//     if (behavior === 'show-add-to-cart') {
//       container.classList.add('hide');
//     } else {
//       container
//         .querySelector(
//           '.btn.btn--full.back-in-stock:not(.back-in-stock-secondary)',
//         )
//         .classList.remove('btn--loading');
//       container.classList.remove('hide');
//     }
//   });
// };

const backInStock = () => {
  const year = document.querySelector('#back-in-stock-year')?.value;
  const month = document.querySelector('#back-in-stock-month')?.value;
  const day = document.querySelector('#back-in-stock-day')?.value;
  const hour = document.querySelector('#back-in-stock-hour')?.value;
  const minute = document.querySelector('#back-in-stock-minute')?.value;
  const timeZone = document.querySelector('#back-in-stock-time-zone')?.value;
  const targetTag = document.querySelector('#back-in-stock-tag')?.value.trim();
  if (!year || !month || !day || !hour || !minute || !timeZone || !targetTag) {
    return;
  }
  window.Shopify.backInStock = {
    ...window.Shopify.backInStock,
    target_tag: targetTag,
  };
  const parsedDate = `${year}-${month}-${day}`;
  const parsedTime = `${hour}:${minute}:00`;
  const timerLopp = new TimerLoop({
    date: parsedDate,
    time: parsedTime,
    timeZone,
    onComplete: () => {
      console.log('Back in stock: Timer completed, showing add to cart');
      window.Shopify.backInStock = {
        state: 'done',
        target_tag: targetTag,
      };
      document.dispatchEvent(
        new CustomEvent('preorder-opener:show-add-to-cart'),
      );
    },
    onHold: () => {
      console.log('Back in stock: Timer waiting, showing preorder');
      window.Shopify.backInStock = {
        state: 'waiting',
        target_tag: targetTag,
      };
      document.dispatchEvent(new CustomEvent('preorder-opener:show-preorder'));
    },
  });
  timerLopp.timerCal();
  timerLopp.initLoop();
};

document.addEventListener('DOMContentLoaded', () => {
  backInStock();
});
